<template>
    <v-card-text>
        <v-row>
            <v-col cols="12" md="6">
                <v-form ref="form" v-model="valido" @submit.prevent="guardar">
                    <v-switch
                        v-model="modelo.correo_auto_certificado"
                        color="success" inset hide-details class="mt-1 mb-4"
                        :disabled="!permisos.editar"
                        :label="modelo.correo_auto_certificado
                            ? 'Envío automático: al procesar una importación se encola el correo de cada certificado'
                            : 'Envío automático desactivado: los correos se encolan a mano desde Envíos'"
                    />

                    <v-text-field
                        v-model.number="modelo.correo_limite_diario"
                        label="Límite diario de correos"
                        type="number" min="1" max="100000"
                        outlined dense
                        prepend-inner-icon="speed"
                        hint="Correos que se envían como máximo en 24 horas; el resto espera en la cola."
                        persistent-hint
                        :disabled="!permisos.editar"
                        :rules="[reglas.limite]"
                    />

                    <v-text-field
                        class="mt-4"
                        v-model="modelo.correo_remitente_nombre"
                        label="Nombre visible del remitente"
                        outlined dense maxlength="80" counter="80"
                        prepend-inner-icon="badge"
                        :hint="`El participante lo verá como: ${modelo.correo_remitente_nombre || 'Certificados INFOP'} <${datos.remitente_direccion || 'sin dirección'}>`"
                        persistent-hint
                        :disabled="!permisos.editar"
                        :rules="[reglas.requerido]"
                    />

                    <v-text-field
                        class="mt-4"
                        v-model="modelo.correo_url_sistema"
                        :label="'Dirección del sistema para el campo {{enlace}}'"
                        outlined dense
                        prepend-inner-icon="link"
                        placeholder="https://certificados.infop.hn"
                        hint="Enlace que recibe el participante para descargar su certificado."
                        persistent-hint
                        :disabled="!permisos.editar"
                        :rules="[reglas.requerido, reglas.url]"
                    />

                    <v-btn v-if="permisos.editar" color="primary" small class="mt-5" :loading="guardando" @click="guardar">
                        <v-icon small left>save</v-icon> Guardar
                    </v-btn>
                </v-form>
            </v-col>

            <v-col cols="12" md="6">
                <v-card outlined class="pa-4">
                    <div class="text-subtitle-2 font-weight-bold mb-3"><v-icon small left color="primary">info</v-icon>Estado del correo saliente</div>
                    <v-simple-table dense>
                        <tbody>
                        <tr>
                            <td class="grey--text text--darken-1">Servidor de correo</td>
                            <td>
                                <v-chip x-small label :color="datos.correo_habilitado ? 'success' : 'grey'" text-color="white">
                                    {{ datos.correo_habilitado ? 'Configurado' : 'No configurado' }}
                                </v-chip>
                                <span v-if="!datos.correo_habilitado" class="text-caption ml-2">Defina MAIL_* y CORREO_HABILITADO=true en el servidor.</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="grey--text text--darken-1">Dirección remitente</td>
                            <td>{{ datos.remitente_direccion || '—' }}</td>
                        </tr>
                        <tr>
                            <td class="grey--text text--darken-1">Envío</td>
                            <td>
                                <v-chip x-small label :color="datos.correo_pausado ? 'warning' : 'success'" text-color="white">
                                    {{ datos.correo_pausado ? 'Pausado' : 'Activo' }}
                                </v-chip>
                                <span class="text-caption ml-2">Se pausa o reanuda desde la pestaña Envíos.</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="grey--text text--darken-1">Frecuencia</td>
                            <td>Cada 10 minutos (cron), hasta {{ datos.lote_por_corrida }} correos por corrida.</td>
                        </tr>
                        <tr>
                            <td class="grey--text text--darken-1">Reintentos</td>
                            <td>Hasta {{ datos.max_intentos }} intentos por correo; después queda "con error".</td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>
    </v-card-text>
</template>

<script>
/** Pestaña Ajustes: envío automático, límite diario, remitente visible y dirección del sistema. */
export default {
    name: "NotificacionesAjustes",
    data() {
        return {
            valido: true,
            guardando: false,
            permisos: {crear: false, editar: false, eliminar: false},
            datos: {correo_habilitado: false, remitente_direccion: "", correo_pausado: false, lote_por_corrida: 0, max_intentos: 0},
            modelo: {correo_auto_certificado: false, correo_limite_diario: 2000, correo_remitente_nombre: "", correo_url_sistema: ""},
            reglas: {
                requerido: v => (v !== null && v !== undefined && String(v).trim() !== "") || "Campo requerido",
                limite: v => (Number.isInteger(Number(v)) && Number(v) >= 1 && Number(v) <= 100000) || "Entre 1 y 100000",
                url: v => /^https?:\/\/\S+$/i.test(String(v || "").trim()) || "Debe empezar con http:// o https://",
            },
        }
    },
    methods: {
        aplicar(d) {
            this.datos = d;
            this.permisos = d.permisos;
            this.modelo = {
                correo_auto_certificado: !!d.correo_auto_certificado,
                correo_limite_diario: d.correo_limite_diario,
                correo_remitente_nombre: d.correo_remitente_nombre || "",
                correo_url_sistema: d.correo_url_sistema || "",
            };
        },
        cargar() {
            window.axios.get("/correos/ajustes").then(response => {
                if (response.data.success) {
                    this.aplicar(response.data.data);
                } else {
                    this.$toast.error(response.data.message);
                }
            }).catch(() => this.$toast.error("No se pudieron cargar los ajustes."));
        },
        guardar() {
            if (!this.$refs.form.validate()) return;

            this.guardando = true;
            const datos = {
                correo_auto_certificado: this.modelo.correo_auto_certificado ? 1 : 0,
                correo_limite_diario: Number(this.modelo.correo_limite_diario),
                correo_remitente_nombre: (this.modelo.correo_remitente_nombre || "").trim(),
                correo_url_sistema: (this.modelo.correo_url_sistema || "").trim(),
            };

            window.axios.post("/correos/ajustes", datos).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.aplicar(response.data.data);
                } else {
                    this.$toast.error(response.data.message, {timeout: 8000});
                }
            })
                .catch(error => {
                    const mensaje = error.response && error.response.data && error.response.data.message;
                    this.$toast.error(mensaje || "No se pudieron guardar los ajustes.", {timeout: 8000});
                })
                .finally(() => {
                    this.guardando = false;
                });
        },
    },
    created() {
        this.cargar();
    },
}
</script>
